import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { DateRange } from "../components/DateSelector";
import { fmtDateApi } from "../utils/date";

export interface MirKvReport {
  operator_name?: string | null;
  total?: number | null;
  comment?: string | null;
  is_primary?: number | null;
  created_at?: string | null;
  /** МК-отметка оператора из отчёта: "score" (5.0) | "cancel" (✕) | "" */
  mk_status?: string | null;
  actual_players?: number | null;
}
/** Полный расчёт игры (19.09, владелец): в карточке — только «за игру», остальное по тапу. */
export interface MirKvMoney {
  /** за игру = цена квеста + ночная надбавка (без чайной, МК и прочих услуг) */
  game: number;
  quest: number; night: number; tea: number; mc: number;
  cash: number; terminal: number; transfer: number; prepaid: number;
  invoice: number; other: number; change: number;
  /** всё оплаченное по игре, включая допуслуги и задаток */
  total: number;
  /** false — отчёта ещё нет, «за игру» взято из ожидания брони */
  hasReport: boolean;
}
export interface MirKvGame {
  id: string | number;
  date: string;
  time: string;
  custom_time?: string | null;
  created_at?: string | null;
  short_name?: string | null;
  quest_name?: string | null;
  branch_name?: string | null;
  client_name?: string | null;
  phone?: string | null;
  players?: number | null;
  /** 19.09 (владелец): «по брони → пришло», как в агрегированном отчёте ОО. */
  actual_players?: number | null;
  /** статус САМОЙ брони — независим от МК-меток (26.08, владелец) */
  status?: string | null;
  /** ЧИСТО интерфейсные метки операторов для агрегатора — ни из чего не выводятся */
  has_score?: boolean; has_cancel?: boolean;
  /** ВСЕГО заплачено: на месте (факт/отчёт) + задаток (26.08, владелец) */
  revenue: number;
  money?: MirKvMoney;
  paid_onsite?: number | null;
  prepaid_amount?: number | null;
  reports: MirKvReport[];
}
export interface MirKvKpi { games: number; score: number; cancel: number; revenue: number }
interface Resp { results?: MirKvGame[]; kpi?: MirKvKpi }

const KPI0: MirKvKpi = { games: 0, score: 0, cancel: 0, revenue: 0 };

/** Игры «Мир Квестов» за период календаря ДК (21.09, владелец; было — один выбранный день). */
export function useMirKv(range: DateRange) {
  const [games, setGames] = useState<MirKvGame[]>([]);
  const [kpi, setKpi] = useState<MirKvKpi>(KPI0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const from = range.start ? fmtDateApi(range.start) : null;
  const to = range.end ? fmtDateApi(range.end) : null;

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    if (!from || !to) return;
    api<Resp>(`/api/bookings/mirkv?from=${from}&to=${to}`)
      .then((r) => {
        if (!alive) return;
        setGames(r.results ?? []);
        setKpi(r.kpi ?? KPI0);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (!alive) return;
        setError(e instanceof Error ? e.message : "Не удалось загрузить Мир Квестов");
        setLoading(false);
      });
    return () => { alive = false; };
  }, [from, to]);

  return { games, kpi, loading, error, oneDay: from === to };
}
